import "./src/styles/base.scss"

export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    window.addEventListener('load', () => {
      import("gsap")
        .then(module => {
          window.gsap = module.gsap
          return import("gsap/SplitText")
        })
        .then(SplitTextModule => {
          window.SplitText = SplitTextModule.SplitText
          window.gsap.registerPlugin(window.SplitText)
        })
        .catch(e => {
          console.error("GSAP registration failed: ", e)
        })
    })
  }
}
